// Form constants: utilized in PI1 and other form creation

export const ID_PREFIX = "pf-";

export const ID_SEP = "-";

export const PF_BRAND = {
  FERTILITY: "FERTILITY",
  EDU: "EDU",
  TUTOR: "TUTOR",
};

export const PF_MARKET = {
  MEDICAL: "MEDICAL",
  DENTAL: "DENTAL",
};

export const PI1_KEYS = {
  ERR: "errors",
  FLD_TTL: "ttlFields",
  FLD_REQ: "reqFields",
  FLD_VLD: "vldFields",
  MSG: "msg",
  META: "meta",
  TOUCHED: "touched",
  VALID: "valid",
  VALS: "values",
  REQ: "req",
  VALS_MULTI: "valuesMulti",
};

export const PI1_FORM_SECTION = {
  LOAN: "loan",
  RECPT: "recipient",
  APPL: "applicant",
  HOME_ADDR: "homeAddr",
  MAIL_ADDR: "mailAddr",
  CONTACT: "contact",
  EXP_INC: "expInc",
  CONSENT: "consent",
  MAIL: "mail",
};

export const PI1_SUBSECTION = {
  MAIL_TOGL: "addrSame",
  R10P: "relationship",
};

export const PI1_ROUTES = {
  APP_BASE: "/patientsolutions/app",
  PI1: "/registration",
  SUBMIT: "/submit-appl",
  INFO: "/client-info",
  VERIFY_EMAIL: "/check-email",
};

export const PI1_AUTH_FAILS = {
  PROV_STATUS_NOT_ACTIVE: "Provider account status not active",
  PREV_APPLICATION: "Applicant with previous application",
  MISSING_INFO: "Missing provider and applicant",
};

// React Number Format: constants used for deciding whic
//  value to refer to for validation, and form state
export const RNF_PROPS = {
  FORMATTED: "formattedValue",
  VALUE: "value",
  NUMBER: "floatValue",
};

export const NAME_PROPS = {
  FNAME: "firstname",
  LNAME: "lastname",
};

export const ADDR_PROPS = {
  STREET: "street",
  STREET2: "aptsuite",
  CITY: "city",
  STATE: "state",
  ZIP: "zip",
};

// Form input states: assumes error state first
// if array, assumes array of values, error then valid
export const FI_STATES = {
  VALID: ["invalid", "valid"],
  TOUCHED: ["not-touched", "touched"],
  TOGL: ["No", "Yes"],
};

// PF user types
export const USER_TYPE = {
  AGENT: "agent",
  APPLICANT: "applicant",
  PRACTICE: "practice",
  PATIENT: "patient",
};

// reference to form input types
// useful for looking up REGEX constants
export const FI_TYPES = {
  PASSWORD: "password",
  POBOX: "poBox",
  PHONE_NUM: "phoneNum",
  DDMMYYYY: "ddmmyyyy",
  MMDDYYYY: "mmddyyyy",
  EMAIL: "email",
  SSN: "ssn",
  SSN_STRING: "ssnString",
  NUM: "num",
  ZIP: "zip",
};

// regex utilized to validate form input data
export const REGEX = {
  password: /^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9!@#$%]{8,30}$/,
  passwordReqOneSpecChar: /^(?=.*[0-9])(?=.*[!@#$%])[a-zA-Z0-9!@#$%]{8,30}$/,
  mmddyyyy: /^(0\d{1}|1[0-2])\/([0-2]\d{1}|3[0-1])\/(19|20)\d{2}$/,
  ddmmyyyy: /^(3[01]|[12][0-9]|0[1-9])(\/)(1[0-2]|0[1-9])(\/)[0-9]{4}$/,
  phoneNum: /^\(?([0-9]{3})\)?[ ]?([0-9]{3})[-]?([0-9]{4})$/,
  poBox: /\b(?:p\.?\s*o\.?|post\s+office)\s+box\b/i,
  email: /\S+@\S+\.\S+/i,
  ssn: /^\d{3}-\d{2}-\d{4}$/,
  ssnString: /^\d{9}$/,
  num: /[^0-9]/,
  zip: /^(?!0{3})\d{5}$/,
};

require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/pages/borrower-registration/styles/borrower-registration.scss');